import About from "../../components/landing/About";
import Blog from "../../components/landing/Blog";
import Contact from "../../components/landing/Contact";
import Faqs from "../../components/landing/Faqs";
import Features from "../../components/landing/Features";
import Footer from "../../components/landing/Footer";
import { Hero } from "../../components/landing/Hero";
import Navigation from "../../components/landing/Navigation";
import Newsletter from "../../components/landing/Newsletter";
import Pricing from "../../components/landing/Pricing";
import Services from "../../components/landing/Services";
import Swiperslider from "../../components/landing/Swiperslider";
import Testimonials from "../../components/landing/Testimonials";
import './Landing.css';

const Landing = () => {
  return (
    <>
      <Navigation />
      <Hero />
      <Services />
      <Features />
      <Newsletter />
      <About />
      <Pricing />
      <Faqs />
      {/*<Swiperslider />
      <Testimonials />
      <Blog />
      <Contact />*/}
      <Footer />
    </>
  );
};

export default Landing;
